module.exports = __webpack_public_path__ + "static/media/cash-icon.158b282f.svg";